// 他 Tab からのお気に入り変更通知を受け取り、IndexedDB から state を読み直す
// 送信側: composables/useFavoriteSync.ts の publish、中継: service-worker/sw.ts
export default defineNuxtPlugin({
  name: "favorite-sync",
  setup() {
    const favoriteSync = useFavoriteSync();

    // Service Worker 経由 (sw.ts が送信元以外の client へ中継する)。受信に controller は不要
    navigator.serviceWorker?.addEventListener("message", (event: MessageEvent) => {
      void favoriteSync.receive(event.data);
    });

    // controller が無い Tab が送った通知は BroadcastChannel で届く
    const channel = favoriteSync.getFallbackChannel();
    channel?.addEventListener("message", (event: MessageEvent) => {
      void favoriteSync.receive(event.data);
    });

    // 安全網: バックグラウンド中に取りこぼした通知があっても前面復帰時に一致させる
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        void favoriteSync.reloadAndNotify("circle");
        void favoriteSync.reloadAndNotify("booth");
        void favoriteSync.reloadAndNotify("colorName");
      }
    });
  },
});
